import React, { Fragment } from 'react';
import { Card, BUTTON_TYPES } from 'day8-react/build/new-components';
import PropTypes from 'prop-types';

const AccomodationOptions = props => (
  <div className="tsw-c-accomodation-options max-width-md margin-auto d8-l-auto-grid">
    {props.destinationId === 6 && (
      <Card
        className="option-left"
        bgColor="d8-u-primary-light-bg"
        topText="COME YOUR WAY"
        heading="Book a room"
        subheading="Room only bookings aren't available on TSW Japan, but don't let that put you off! We have many other likeminded adventure seekers looking to join forces, so head on over to our Crew Finder to link up!"
        cta={{ text: 'Crew finder', link: '/crew-finder', buttonType: BUTTON_TYPES.WHITE }}
        whiteFont
      />
    )}
    {props.destinationId === 3 && (
      <Card
        className="option-left"
        bgColor="d8-u-primary-light-bg"
        topText="COME YOUR WAY"
        heading="Book a room or solo spot"
        subheading="You can either choose a solo spot or private room in a shared apartment. You'll be assigned an apartment which you will share with other Ski Weekers."
        cta={{ text: 'See available rooms', link: '/book', buttonType: BUTTON_TYPES.WHITE }}
        whiteFont
      />
    )}
    {props.destinationId === 5 && (
      <Fragment>
        <Card
          className="option-left"
          bgColor="d8-u-primary-light-bg"
          topText="COME YOUR WAY"
          heading="Book a room"
          subheading="Have a hotel room to yourself and fill it with friends. You’ll choose your own room which you can share with up to 3 others."
          cta={{ text: 'See available rooms', link: '/book', buttonType: BUTTON_TYPES.WHITE }}
          whiteFont
        />
        <Card
          className="option-right"
          bgColor="d8-u-primary-bg"
          topText="COME YOUR WAY"
          heading="Group Bookings"
          subheading="Got lots of friends keen to join? Drop us a line and we’ll be happy to help!"
          cta={{ text: 'See group options', link: '/contact', buttonType: BUTTON_TYPES.WHITE }}
          whiteFont
        />
      </Fragment>
    )}
    {props.destinationId !== 6 && props.destinationId !== 5 && props.destinationId !== 3 && (
      <Card
        className="option-left"
        bgColor="d8-u-primary-light-bg"
        topText="COME YOUR WAY"
        heading="Book a room"
        subheading="A private room gives you one bedroom in a shared apartment. You'll be assigned an apartment which you will share with 2-4 other Ski Weekers."
        cta={{ text: 'See available rooms', link: '/book', buttonType: BUTTON_TYPES.WHITE }}
        whiteFont
      />
    )}
    {props.destinationId !== 5 && (
      <Card
        className="option-right"
        bgColor="d8-u-primary-bg"
        topText="COME YOUR WAY"
        heading="Book an entire flat"
        subheading="Have an apartment to yourself and fill it with friends. You'll choose your own apartment which you can share with up to 8 others."
        cta={{ text: 'See available apartments', link: '/book', buttonType: BUTTON_TYPES.WHITE }}
        whiteFont
      />
    )}
  </div>
);

AccomodationOptions.propTypes = {
  destinationId: PropTypes.number
};

export default AccomodationOptions;
